// 用户相关的函数

import { erase, get } from "browser-cookies"
import { User } from "Types/user"
import { Menu } from "Types/menu"

export const TOKEN_NAME = "ad_token"
export const UID_NAME = "uid"
export const loginPath = "/login"
export const profilePath = "/settings"
// 获取用户客户端登录态信息
export function getUserLocalInfo() {
    const token = get(TOKEN_NAME) || ""
    const uid = get("uid") || ""
    const isLogin = !!token && !!uid
    return { token, uid, isLogin }
}
// 跳转登录页
export function redirectLogin() {
    erase(TOKEN_NAME)
    erase(UID_NAME)
    window.location.href = loginPath

}
// 跳转个人设置页
export function redirectProfile() {
    window.location.href = profilePath
}
function menuFilter(menuItem: Menu, roleMap: { [key: string]: boolean }, role_name: string, type_name: string) {
    switch (menuItem.url) {
        case '/beauty_calendar':
            // 前述权限taiga不详
            // 增加营销部可见：http://taiga.iguokr.com/project/liyang-noah/us/2435
            // 电商内容 编辑部编辑可见
            return roleMap.isAdmin || ['beauty', 'business', 'marketing'].includes(type_name) || ('newmedia' === type_name && 'side_editor' === role_name)
        case '/species_calendar':
            // 权限：http://taiga.iguokr.com/project/liyang-noah/us/2410
            // 管理员及以下部门可见：编辑部、商务部、市场部、科普服务部、放大灯、Datamuse、电商新媒体、视频部、营销部、果壳儿童、豆选咖啡、产品运营部、财务部
            return roleMap.isAdmin || ['editor', 'business', 'market', 'science', 'lamp', 'datamuse', 'newmedia', 'video', 'marketing', 'children', 'coffee', 'om', 'finance', 'nuts'].includes(type_name)
        case '/eat_calendar':
            // 权限：https://taiga.iguokr.com/project/yan-fa-shi-yan-shi/us/1224?milestone=627
            // 除了财务均可见
            return roleMap.isAdmin || !['finance'].includes(type_name)
        default:
            return true
    }
}
// 格式化用户侧边栏菜单和权限信息
export function parseUserInfo(user?: User) {
    const mainList: Menu[] = []
    const privilegeMap: { [key: string]: { [key: string]: boolean } } = {}
    const roleMap: { [key: string]: boolean } = {}
    if (user) {
        const { role, hidden, department } = user

        const { role_name = '' } = role || {}
        const { type_name = '' } = department || {}
        roleMap.isTrueEditor = role_name === "true_editor"
        roleMap.isSideEditor = role_name === "side_editor"
        roleMap.isOpEditor = role_name === "op_editor"
        roleMap.isFinance = role_name === "finance"
        roleMap.isAdmin = role_name === "admin"
        roleMap.isUser = role_name === "user"
        roleMap.isPhotoer = role_name === "photoer"

        roleMap.isBeauty = type_name === "beauty"
        roleMap.isBusiness = type_name === "business"
        const { menus = [], role_privileges: privileges = [] } = role || {}
        for (const privilege of privileges) {
            const { privilege: { obj_type } } = privilege
            if (obj_type === "resource") {
                const { privilege: {
                    resource: { name },
                    action: {
                        action_code,
                    },
                } } = privilege
                privilegeMap[name] = {
                    insert: action_code.charAt(0) === "1",
                    delete: action_code.charAt(1) === "1",
                    update: action_code.charAt(2) === "1",
                    get: action_code.charAt(3) === "1",
                }
            }
        }
        for (const menu of menus.sort((a: Menu, b: Menu) => { return a.seq_num - b.seq_num })) {
            const isTopMenu = menu.parent_id === 0 && menu.child_menus
            if (isTopMenu) {
                menu.child_menus = (menu.child_menus || []).filter((menuItem) => menuFilter(menuItem, roleMap, role_name, type_name))
                mainList.push(menu)
            }
        }
    }
    return { mainList, privilegeMap, roleMap }
}
